import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { EntriesService } from '../entries.service';
@Injectable({
  providedIn: 'root',
})
export class EntriesDetailsResolver {
  constructor(private entriesService: EntriesService) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.entriesService.getEntry(route.params['id']);
  }
}
